/**
 * @fileoverview Agent definition for world-place-details-generator-v3.
 *
 * This agent generates complete details for a world place based on a
 * selected creative direction from the details ideation agent.
 *
 * @category world-building.places.details
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'world-place-details-generator-v3',
  kind: 'primitive',
  name: 'World Place Details Generator',
  description: 'Generates complete details for a world place based on a selected creative direction.',
  category: 'world-building',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-01',
    taxonomyPath: 'world-building.places.details',
    usedBy: [
      'use-world-place-details-generator-v3.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'world-place-details-ideation-v3',
      'world-place-snapshotter-v3',
    ],
  },
};
